import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';


import { Observable } from 'rxjs/RX';
import { Subject } from "rxjs";

import { IAuthData, HttpOptions, ePrivileges, IKey, IKeyRequest, eLocalStorageItems, ILoginStatus } from '../models';
import { environment } from '../../../environments/environment';



@Injectable()
export class AuthenticationService {
    private httpOptions: HttpOptions;
    private apiUrl = environment.api_url;
    private deployment = environment.deployment;

    private currentAccessPrivileges: string[] = [];
    private loginData: ILoginStatus = {};
    

    public camerasChangedSubject = new Subject();
    public permissionsChangedSubject = new Subject();

    public permissionsChangedVisible = false;

    constructor(private http: HttpClient, private msalService: MsalService) {  
             
        const data_accessPrivileges = localStorage.getItem(this.deployment + eLocalStorageItems.accessPrivileges);
        const data_access_token = localStorage.getItem(this.deployment + eLocalStorageItems.accessToken);
    
        if (!data_accessPrivileges || !data_access_token) {
            this.removeAuthenticationData();
        } else {
            this.currentAccessPrivileges = data_accessPrivileges.split(',').map(x => x.trim());
            this.saveAuth(data_access_token);
            this.setAuthHeader(data_access_token);
        }
    }

    //constructor(private http: HttpClient) {  
    //         
    //    const data_accessPrivileges = localStorage.getItem(this.deployment + eLocalStorageItems.accessPrivileges);
    //    const data_access_token = localStorage.getItem(this.deployment + eLocalStorageItems.accessToken);
    //
    //    if (!data_accessPrivileges || !data_access_token) {
    //        this.removeAuthenticationData();
    //    } else {
    //        this.currentAccessPrivileges = data_accessPrivileges.split(',').map(x => x.trim());
    //        this.saveAuth(data_access_token);
    //        this.setAuthHeader(data_access_token);
    //    }
    //}

    public getAuthHttpOptions() {
        return this.httpOptions;
    }

    public getToken(user: string, password: string) {        

        const data = 'grant_type=password&username=' + user + '&password=' + btoa(password);
        // console.log(`getToken: [${this.apiUrl + 'Token'}] data=[${data}]`);
        return this.http.post(this.apiUrl + 'Token', data);
    }

    public  loginSsoAzureAD()  {        
        
        // Account object with the following signature:
        //      homeAccountId - Home account identifier for this account object
        //      environment - Entity which issued the token represented by the domain of the issuer (e.g. login.microsoftonline.com)
        //      tenantId - Full tenant or organizational id that this account belongs to
        //      username - preferred_username claim of the id_token that represents this account
        //      localAccountId - Local, tenant-specific account identifer for this account object, usually used in legacy cases
        //      name - Full name for the account, including given name and family name
        //      idToken - raw ID token
        //      idTokenClaims - Object contains claims from ID token
        //      nativeAccountId - The user's native account ID
        //      tenantProfiles - Map of tenant profile objects for each tenant that the account has authenticated with in the browser
        var loginRequest = {
            scopes: ['User.Read', 'openid', 'profile'], // optional Array<string>
            loginHint: "user@Arcadis.com",
        };
        console.log(`loginSsoAzureAD: scopes=[${loginRequest.scopes}] loginHint=[${loginRequest.loginHint}]`);
        return this.msalService.loginPopup(loginRequest);        
                               
    }

    

    public getKeyCode(keyR: IKeyRequest, options) {
        return this.http.post(this.apiUrl + 'Code/GetKeyCode', keyR, options);
    }

    public sendBackKeyCode(key: IKey, options) {
        return this.http.post(this.apiUrl + 'Code/VerifyCode', key, options);
    }

    // get the user login state from the server
    public getLoginStatus(): Observable<any> {
        return this.http.get<any>(this.apiUrl + 'LoginStatus/GetLoginStatus', this.getAuthHttpOptions());
    }

    public logout() {
        return this.http.post(this.apiUrl + 'Users/Logout', null, this.getAuthHttpOptions());
    }

    // after login
    public setAuth(data: any) {
        let authData: IAuthData = {
            userName: data['userName'],
            accessToken: data['access_token'],
            accessPrivileges: data['accessPrivileges']
        };
        this.currentAccessPrivileges = authData.accessPrivileges.split(',').map(x => x.trim());
        
        console.log(`setAuth: authData.accessToken=[${authData.accessToken}]`);
        this.saveAuth(authData.accessToken);
        this.setAuthHeader(authData.accessToken);
    }

    public removeAuthenticationData() {
        this.currentAccessPrivileges = [];
        const data_accessPrivileges = localStorage.getItem(this.deployment + eLocalStorageItems.accessPrivileges);
        const data_access_token = localStorage.getItem(this.deployment + eLocalStorageItems.accessToken);
        const data_userName = localStorage.getItem(this.deployment + eLocalStorageItems.userName);

        if (!data_accessPrivileges && !data_access_token && !data_userName) {
            return;
        }

        this.logout().subscribe(() => {
            console.log('User\'s token removed');
        },
            err => {
                console.log('Failed to remove user\'s token ' + err);
            },
            () => {
                const userId = localStorage.getItem(this.deployment + eLocalStorageItems.userId);
                localStorage.removeItem(this.deployment + eLocalStorageItems.accessToken);
                localStorage.removeItem(this.deployment + eLocalStorageItems.userName);
                localStorage.removeItem(this.deployment + eLocalStorageItems.wu);
                localStorage.removeItem(this.deployment + eLocalStorageItems.userId);
                localStorage.removeItem(this.deployment + eLocalStorageItems.accessPrivileges);
                sessionStorage.removeItem(this.deployment + eLocalStorageItems.tempLocationForUserId + userId);

                this.httpOptions = new HttpOptions;
            });
    }

    public hasPrivilege(privilege: ePrivileges): boolean {
        if (this.currentAccessPrivileges && this.currentAccessPrivileges.length > 0) {
            if (this.currentAccessPrivileges.includes(privilege) ||
                this.currentAccessPrivileges.includes(ePrivileges.SystemAdmin)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public setCurrentAccessPrivileges(permissions: string[]) {
        if (this.currentAccessPrivileges.toString() !== permissions.toString()) {
          
            localStorage.setItem(this.deployment + eLocalStorageItems.accessPrivileges, permissions.toString());
          
            this.currentAccessPrivileges = permissions;
            this.permissionsChangedSubject.next();
        }
    }

    public setCamerasInfo(data: ILoginStatus) {
        if (this.loginData.blockedAgencies && this.loginData.blockedAgencies.toString() !== data.blockedAgencies.toString() ||
            this.loginData.agencies && this.loginData.agencies.toString() !== data.agencies.toString() ||
            this.loginData.camerasDateTime && data.camerasDateTime > this.loginData.camerasDateTime ||
            this.loginData.canBlockAgencies && data.canBlockAgencies.toString() != this.loginData.canBlockAgencies.toString()) {
                this.camerasChangedSubject.next();
        }
        this.loginData = data;
    }

    public isLoggedIn(): boolean {
        const data_accessPrivileges = localStorage.getItem(this.deployment + eLocalStorageItems.accessPrivileges);
        const data_access_token = localStorage.getItem(this.deployment + eLocalStorageItems.accessToken);
        const data_userName = localStorage.getItem(this.deployment + eLocalStorageItems.userName);

        if (data_accessPrivileges && data_access_token && data_userName) {
            return true;
        } else {
            return false;
        }
    }

    public getUserID(): number {
        return +localStorage.getItem(this.deployment + eLocalStorageItems.userId);
    }

    private saveAuth(accessToken: string) {
        localStorage.setItem(this.deployment + eLocalStorageItems.accessToken, accessToken);
    }

    private setAuthHeader(accessToken: string) {
        this.httpOptions = new HttpOptions;
        this.httpOptions.headers
            = new HttpHeaders().set('Authorization', 'Bearer ' + accessToken);
    }
}
